export default __webpack_public_path__ + "static/media/project.c297e786.png";